import { render } from "./politics.vue?vue&type=template&id=299428fa"
import script from "./politics.js?vue&type=script&lang=js&external"
export * from "./politics.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__